import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import SectionLabel from '../components/SectionLabel';
import FaqItem from '../components/FaqItem';
import Skeleton, { EmptyState } from '../components/Skeleton';
import { fetchFaqs, useLive } from '../data/live';

export default function FaqPage() {
  const { meeting } = useOutletContext();
  const event = meeting._event;
  const seriesId = event?.meeting_series?.id || event?.series_id;

  const faq = useLive(fetchFaqs, [event?.id, seriesId]);
  const [open, setOpen] = useState(null);

  if (faq === undefined) return <Skeleton variant="card" count={5} />;
  if (!faq || !faq.length) {
    return <EmptyState>Frequently asked questions will be posted here soon.</EmptyState>;
  }

  return (
    <>
      <div className="portal-overview-body">
        Answers to the most common questions about {meeting.org} {meeting.dates}. Tap a question to expand.
      </div>

      <SectionLabel right={`${faq.length}`}>Frequently asked</SectionLabel>
      <div className="portal-faq-list">
        {faq.map((item, i) => (
          <FaqItem
            key={i}
            index={i}
            question={item.q}
            answer={item.a}
            open={open === i}
            onToggle={() => setOpen(open === i ? null : i)}
          />
        ))}
      </div>
    </>
  );
}
